// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"2c497ee1","337":"8516dca8","939":"ca9354fc"}[chunkId] + ".chunk.js";
};